module.exports = __webpack_public_path__ + "static/media/call-end-white-icon.6677eaee.svg";